import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import { sideFieldCount } from '../../createWarningComp/CommonMethods';
import InputGroup from '../../inputComp/InputGroup';
import { CloseIcon, DepartmentIcon, EmailIcon, MobileIcon, SearchIcon, UserIcon } from '../../iconSet/IconSet';
import { InputGroupPropsTypes } from '../../inputComp/InputGroupType';
import { APICallGenerateProcKeyRequest, APICallNewSubscriberGroupRequest, APIGroupTypes, APISubscribeGroupNewTypes, ResponseTypes } from '../../../services/APIEarlyWarningService';
import AlertDialog from '../../popupComp/AlertDialog';
import { FullGroupDataRow, GroupDataRow } from '../../earlyWarning/emailComp/EmailTypes';
import { SelectItemTypes } from '../../../CommonTypes';
import useInputValidate from '../../../hooks/useInputValidate';

import loadLightIcon from '../../../images/icons/load-light.gif'
import loadDarkIcon from '../../../images/icons/load-dark.gif'
import { useTheme } from '../../../context/ThemeContext';
import LoadingScreen from '../../loadingScreenComp/LoadingScreen';

const AddGroup = () => {
    // Loading screen
	const [isLoading, setIsLoading] = useState<boolean>(false);

    const {validateField} = useInputValidate()
    const { theme } = useTheme()
	
	const [alertDialogState, setAlertDialogState] = useState(false);
	const [alertTitle, setAlertTitle] = useState('');
	const [alertDescription, setAlertDescription] = useState('');
	const [alertCallback, setAlertCallback] = useState<() => void | undefined>();

	const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
    const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK
    
        const showAlertDialog = (
        title: string,
        description: string,
        yesCallback?: () => void,
        okCallback?: () => void
        ) => {
        setAlertTitle(title);
        setAlertDescription(description);
        setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
        setAlertOkCallback(() => okCallback);   // Will trigger only on OK
        setAlertDialogState(true);
        };

    const [isUpdate, setIsUpdate] = useState(false);
	const [isDataPickerOpen, setIsDataPickerOpen] = useState<boolean>(false);
    const [isDataPickerLoading, setIsDataPickerLoading] = useState<boolean>(false);
	//const [isRoleSelectOpen, setIsRoleSelectOpen] = useState<boolean>(false);

    const allGroups = useRef<FullGroupDataRow[]>([]);
    const [filteredData, setFilteredData] = useState<FullGroupDataRow[]>([]);

	const [titleName, setTitleName] = useState<string>("setup groups")

	const BASE_URL = process.env.REACT_APP_BASE_URL

	// Form fields
    const groupIdRef = useRef<HTMLInputElement | null>(null);
    const groupNameRef = useRef<HTMLInputElement | null>(null);
    const groupDescriptionRef = useRef<HTMLInputElement | null>(null);
    const groupOrganizationRef = useRef<HTMLSelectElement | null>(null);
    const groupDepartmentRef = useRef<HTMLSelectElement | null>(null);

    const groupMsgEnglishRef = useRef<HTMLTextAreaElement | null>(null)
    const groupMsgDhivehiRef = useRef<HTMLTextAreaElement | null>(null)
    const groupMsgBengaliRef = useRef<HTMLTextAreaElement | null>(null)
    const groupMsgTypeRef = useRef<HTMLInputElement | null>(null)

    const [organizations, setOrganizations] = useState<SelectItemTypes[]>([]);
    const [departments, setDepartments] = useState<SelectItemTypes[]>([]);

    useEffect(() => {
        const token = localStorage.getItem("access_token");
        //fetch("https://bos.beconx.live/api/v1/getallorganizations", {
        fetch(BASE_URL + "/identity_manager/api/v1/getallorganizations", {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
          .then((res) => res.json())
          .then((data) => {
            const formatted = data.map((org: any) => ({
              value: org.organizationid,
              name: org.organizationname,
            }));
            setOrganizations(formatted);
          })
          .catch((err) => console.error("Error fetching organizations:", err));

          fetch(BASE_URL + "/identity_manager/api/v1/getalldepartments", {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            })
            .then((res) => res.json())
            .then((data) => {
                const foundData: SelectItemTypes[] = []
                //console.log(data)
                data.map((item: any)=> {
                    const tempData: SelectItemTypes = {
                        name: item.departmentname,
                        value: item.departmentid
                    }
                    foundData.push(tempData)
                })
                setDepartments(foundData)
            })
            .catch((err) => console.error("Error fetching organizations:", err));
      }, []);

     

	const formItems: InputGroupPropsTypes[] = [
        {
			type: "text",
			icon: <UserIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Group Id",
			label: "id",
			componentInputElement: groupIdRef,
			name: "group-id",
			required: true,
            dataPicker: true,
			isDataPickerOpen: isDataPickerOpen,
			setIsDataPickerOpen: setIsDataPickerOpen,
            disabled: true
		},
		{
			type: "text",
			icon: <UserIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Group name",
			label: "Group name",
			componentInputElement: groupNameRef,
			name: "group-name",
			required: true,
		},
        {
			type: "text",
			icon: <UserIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Group description",
			label: "group description",
			componentInputElement: groupDescriptionRef,
			name: "group-description",
			required: false,
		},
        {
			type: "select",
			icon: <MobileIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Group organization",
			label: "group organization",
			componentSelectElement: groupOrganizationRef,
            optionList: organizations,
			name: "group-organization",
			required: true,
		},
        {
			type: "select",
			icon: <DepartmentIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Group department",
			label: "group department",
			componentSelectElement: groupDepartmentRef,
            optionList: departments,
			name: "group-department",
			required: true,
		}
    ]

    // const groupMsgEnglishRef = useRef<HTMLTextAreaElement | null>(null)
    // const groupMsgDhivehiRef = useRef<HTMLTextAreaElement | null>(null)
    // const groupMsgBengaliRef = useRef<HTMLTextAreaElement | null>(null)
    // const groupMsgTypeRef = useRef<HTMLInputElement | null>(null)

    const handleSave = async () => {
        const groupNameField = validateField(groupNameRef)

        if (groupNameField)
        {
            if (groupIdRef.current && groupNameRef.current && groupDescriptionRef.current && groupOrganizationRef.current && groupDepartmentRef.current && groupMsgEnglishRef.current && groupMsgDhivehiRef.current && groupMsgBengaliRef.current && groupMsgTypeRef.current)
            {
            
                const newSubmitData: APISubscribeGroupNewTypes = {
                    id: groupIdRef.current.value,
                    groupName: groupNameRef.current.value,
                    groupDescription: groupDescriptionRef.current.value,
                    groupOrganization: groupOrganizationRef.current.value,
                    groupDepartment: groupDepartmentRef.current.value,

                    groupMsgType: groupMsgTypeRef.current.checked,
                    groupMsgEn: groupMsgEnglishRef.current.value,
                    groupMsgDv: groupMsgDhivehiRef.current.value,
                    groupMsgBn: groupMsgBengaliRef.current.value
                }

                //console.log("BODY -> ", newSubmitData)
                setIsLoading(true)
                const response = await APICallNewSubscriberGroupRequest(newSubmitData)
                setIsLoading(false)

                if (response.httpStatus === "OK")
                {
                    //console.log("✅ group successfully added");
                    showAlertDialog("Success", "✅ Group successfully added!", undefined, () => window.location.reload());
                } else {
                    //console.log("error while adding group")
                    showAlertDialog("Error", "❌ Error adding data");
                }
            }
        }
    }

    const handleClickFilteredGroups = (group: FullGroupDataRow) => {
        if (groupIdRef.current && groupNameRef.current && groupDescriptionRef.current && groupOrganizationRef.current && groupDepartmentRef.current && groupMsgTypeRef.current && groupMsgEnglishRef.current && groupMsgDhivehiRef.current && groupMsgBengaliRef.current) 
        {
            groupIdRef.current.value = group.groupid
            groupNameRef.current.value = group.groupname
            groupDescriptionRef.current.value = group.groupdescription
            groupOrganizationRef.current.value = group.organization
            groupDepartmentRef.current.value = group.department

            groupMsgTypeRef.current.checked = group.groupMsgType
            groupMsgEnglishRef.current.value = group.groupMsgEn
            groupMsgDhivehiRef.current.value = group.groupMsgDv
            groupMsgBengaliRef.current.value = group.groupMsgBn
        }

        setIsDataPickerOpen(false);
        setIsUpdate(true);
    }

    const handleChangeExistingDataSearch = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === "") {
            setFilteredData(allGroups.current);
        } else {
        setFilteredData(
            allGroups.current.filter((item) =>
                item.groupname.toLowerCase().includes(event.target.value.toLowerCase()) ||
                item.department.toLowerCase().includes(event.target.value.toLowerCase())
            )
        );
        }
    }

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const response = await APICallGenerateProcKeyRequest("GRP"); // Pass prop here
                if (response && !response.errorCode) {
                    //console.log("✅ API data loaded: ", response);
                    // Example: store a process key in state
                    // setProcKey(response.processKey);

                    if (groupIdRef.current) {
                        groupIdRef.current.value = response.data;
                    }

                } else {
                    console.warn("⚠️ API returned an error:", response?.errorMessage);
                    showAlertDialog("Error", "❌ Failed to load initial data");
                }
            } catch (error) {
                console.error("❌ Error fetching data:", error);
                showAlertDialog("Network Error", "Failed to fetch initial data.");
            }
        };

        fetchInitialData();
    }, []); 

    const getAllGroups = () => {
        setIsDataPickerLoading(true)
        const token = localStorage.getItem("access_token");
        fetch(BASE_URL + "/ew/api/v1/getallgroup", {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((data) => {
                allGroups.current = data;
                setFilteredData(data);
                //console.log("Data: ", data)
            })
            .catch((err) => console.error("Error fetching roles:", err))
            .finally(() => setIsDataPickerLoading(false))
            
    }
        
    useEffect(() => {
        getAllGroups()
    }, [])
    
    const handleDeleteGroup = async () => {
		const token = localStorage.getItem("access_token");
		if (!token) {
      		showAlertDialog("Unauthorized", "❌ Missing access token.");
			return;
		}

        if (groupIdRef.current){
            setIsLoading(true)
            try {
			//const response = await fetch(`https://bos.beconx.live/api/v1/delete/${form.username}`,
			const response = await fetch(BASE_URL + `/ew/api/v1/delete_group?id=${groupIdRef.current.value}`,
				{
					method: "GET",
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			if (response.ok) {
                setIsUpdate(false);
                showAlertDialog("Deleted", "✅ Group deleted successfully", undefined, () => window.location.reload());
			} else {
				const contentType = response.headers.get("content-type");
				if (contentType && contentType.includes("application/json")) {
					const error = await response.json();
					console.log(error.message || "Error deleting user");
                    showAlertDialog("Error", "❌ Error deleting group");
				} else {
					const errorText = await response.text();
					console.log(errorText);
                    showAlertDialog("Error", "❌Error deleting subscriber");
				}
			}
		} catch (err) {
			console.error("Delete failed", err);
			console.log("An error occurred during deletion");
		}
        finally{
            setIsLoading(false)
        }
        }
    }

	return (
		<div className={`container-wrapper`}>
			<span className={`title`}>{titleName}</span>

			<div className={`add-groups`}>
                <div className={`grid-layout-add-subscribers`}>
                    <div className={`left-side`}>
                        {formItems.slice(0, sideFieldCount(formItems.length)).map((field, index) => (
                        <InputGroup key={index} {...field} />
                        ))}
                    </div>

                    <div className={`right-side`}>
                        {formItems.slice(sideFieldCount(formItems.length)).map((field, index) => (
                        <InputGroup key={index} {...field} />
                        ))}
                    </div>

                    <div className="message-container">
                        <div className='form-container' style={{ alignItems: 'center', marginBottom: '1rem', justifyContent: 'flex-end' }}>
                            <label htmlFor='group_msg_check' style={{ color: 'var(--color-text)', cursor: 'pointer' }}>Activate generalised messages for this group</label>
                            <input type='checkbox' name="" id="group_msg_check" style={{ marginRight: '0.5rem', cursor: 'pointer' }} ref={groupMsgTypeRef} />
                        </div>
                        <div className='form-container'>
                            <span>localize message body - english</span>
                            <textarea ref={groupMsgEnglishRef} name="" id=""></textarea>
                        </div>
                        <div className='form-container'>
                            <span>localize message body - dhivehi</span>
                            <textarea ref={groupMsgDhivehiRef} name="" id=""></textarea>
                        </div>
                        <div className='form-container'>
                            <span>localize message body - Bengali</span>
                            <textarea ref={groupMsgBengaliRef} name="" id=""></textarea>
                        </div>
                    </div>
                    
                    <div className={`button-wrapper`} style={{ gridArea: "button" }}>
                        <div className={`left-side`}></div>
                        <div className={`right-side`}>
                            <button
                                className={`button-normal`}
                                onClick={(e) => handleSave()}
                            >
                                {isUpdate ? "Update" : "Create"}
                            </button>
                            {isUpdate && (
								<button className={`button-normal`} style={{backgroundColor: 'var(--color-main-red)'}} onClick={(e) =>
									showAlertDialog(
										"Confirm Delete",
										"Are you sure you want to delete this group?",
										() => handleDeleteGroup()
									) 
                                
								}>Delete</button>
							)}
                        </div>
                    </div>
                    {isDataPickerOpen && (
                        <div className="data-picker-table-wrapper">
                            <div className="data-picker-table-container">
                                <div className="search-wrapper">
                                    <input
                                        type="text"
                                        placeholder="Search Groups"
                                        onChange={(e) => handleChangeExistingDataSearch(e)}
                                    />
                                    <div className="search-icon">
                                        <SearchIcon
                                            width="1rem"
                                            color="var(--color-main-white)"
                                        />
                                    </div>
                                    <div
                                        className="close-icon"
                                        onClick={(e) => setIsDataPickerOpen(false)}
                                    >
                                        <CloseIcon width="1.5rem" color="var(--color-text)" />
                                    </div>
                                </div>
                                <div className="row header">
									<span style={{ width: '50%' }}>Group Name</span>
									<span style={{ width: '50%' }}>Department</span>
								</div>

								{isDataPickerLoading ? (
									<div className="searching-data">
										<img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} alt="" />
										<span>Searching subscriber groups data...</span>
									</div>
									) : (
										<div className="data-wrapper">
                                            {filteredData.map((group, index) => (
                                                <div
                                                    key={index}
                                                    className="row"
                                                    onClick={(e) => handleClickFilteredGroups(group)}
                                                >
                                                    <span style={{ width: '50%' }}>{group.groupname}</span>
                                                    <span style={{ width: '50%' }}>{group.departmentName}</span>
                                                </div>
                                            ))}
                                        </div>
									)}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {alertDialogState && (
            <AlertDialog
                title={alertTitle}
                description={alertDescription}
                windowState={alertDialogState}
                setWindowState={setAlertDialogState}
                function={alertYesCallback}
                okFunction={alertOkCallback}
            />
            )}
            {isLoading && (
                <LoadingScreen />
            )}
		</div>
	)
}

export default AddGroup